import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { isColorValueAvailable, isColorValueSelected } from 'selectors/facets/colorFacet'

const mapStateToProps = createStructuredSelector({
  isAvailable: (state, ownProps) => isColorValueAvailable(ownProps.color)(state),
  isSelected: (state, ownProps) => isColorValueSelected(ownProps.color)(state),
})

export type ColorFacetConnectorProps = {
  isAvailable: boolean
  isSelected: boolean
}
export default connect(mapStateToProps)
